module.exports = __webpack_public_path__ + "static/img/8_2.a50fecd3.jpg";